import { render } from "./OrganizationStructureLayout.vue?vue&type=template&id=19dbfd4c&scoped=true"
import script from "./OrganizationStructureLayout.vue?vue&type=script&lang=js"
export * from "./OrganizationStructureLayout.vue?vue&type=script&lang=js"

import "./OrganizationStructureLayout.vue?vue&type=style&index=0&id=19dbfd4c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19dbfd4c"]])

export default __exports__